import { createMainResourceREST, mergeSummaryBodyField } from '../resource';
import {
  CRStringListBody,
  CRStringListBodyAPI,
  CRStringListKey,
  CRStringListSummary,
  CRStringListSummaryAPI,
  StringListActions,
  StringListsState,
} from './types';

type AnyStringList =
  | CRStringListKey
  | CRStringListSummary
  | CRStringListBody
  | undefined;

function sameKeyStringList(a: AnyStringList, b: AnyStringList): boolean {
  return a?.stringListId === b?.stringListId;
}

function getEndpointStringList(key: AnyStringList): string {
  return key ? `/string-lists/${key.stringListId}/` : '/string-lists/';
}

function parseStringListSummary(
  stringListSummary: CRStringListSummaryAPI,
): CRStringListSummary {
  return stringListSummary;
}

function parseStringListBody(
  stringListDetail: CRStringListBodyAPI,
): CRStringListBody {
  return stringListDetail;
}

const stringListsStateSelector = (state: any): StringListsState =>
  state.stringLists;

const stringListsKeySelector = ({
  stringListId,
}: CRStringListBody | CRStringListSummary): CRStringListKey => ({
  stringListId,
});

function mergeStringListBody(
  lastBody: CRStringListBody,
  currentBody: CRStringListBody,
) {
  return currentBody;
}

function combineSummaryBodyStringList(
  summary?: CRStringListSummary,
  body?: CRStringListBody,
): CRStringListSummary {
  const merge = mergeSummaryBodyField(summary, body);

  return {
    rowKey: merge('rowKey'),
    stringListId: merge('stringListId'),
    stringListType: merge('stringListType'),
    value: merge('value'),
    inUse: merge('inUse'),
    enabledForChild: merge('enabledForChild'),
  };
}

const { actions, reducer, watches } = createMainResourceREST(
  'stringLists',
  getEndpointStringList,
  stringListsStateSelector,
  sameKeyStringList,
  parseStringListBody,
  parseStringListSummary,
  mergeStringListBody,
  combineSummaryBodyStringList,
);

const stringListActions: StringListActions = actions;
export * from './types';
export {
  stringListActions,
  reducer as stringListsReducer,
  watches as stringListsWatches,
  stringListsStateSelector,
  stringListsKeySelector,
  getEndpointStringList,
};
